import User from '@/shared/models/user/user';
import Domain from '@/shared/models/domain';
import Customer from '@/shared/models/customer/customer';

export enum UserAuthorityRole {
  BO_ADMIN = 'bo_admin',
  BO_DATASETS_REVIEWER = 'bo_datasets_reviewer',
}

interface AuthData {
  accessToken: string;
  refreshToken: string;
  user: User;
  domain: Domain;
  customer: Customer;
  updatedAt: number;
  authorities: Authority[];
}

interface Authority {
  id: UserAuthorityRole;
}

export default AuthData;
